export default __webpack_public_path__ + "static/media/zonapro-regular.12a07afc.otf";